// src/App.tsx
import { BrowserRouter as Router } from "react-router-dom";
import { AppRoutes } from "./Routes";
import React from "react";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

function App() {
  React.useLayoutEffect(() => {
    if (window.location.hostname === "facebook.earthboundmartian.com") {
      window.location.replace("https://facebook.com/earthboundmartian");
    }
    if (window.location.hostname === "instagram.earthboundmartian.com") {
      window.location.replace("https://instagram.com/earthboundmart1");
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <AppRoutes />
    </Router>
  );
}

export default App;
